import computeMilesToMeters from '../utils/computeMilesToMeters'

export const SearchRadiusInMiles = {
  CITY: 250,
  REGION: 500,
  COLLOQUIAL_AREA: 500,
  TERRITORY: 1000,
  COUNTRY: 1500,
  CONTINENT: 20000
}

export const SearchRadiusInMeters = {
  ...Object.keys(SearchRadiusInMiles).reduce((acc, key) => {
    acc[key] = computeMilesToMeters(SearchRadiusInMiles[key])
    return acc
  }, {})
} as typeof SearchRadiusInMiles

export const AROUND_RADIUS_GLOBAL = 'all'
